import React from "react";
import {
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    Button,
    Flex,
} from "@chakra-ui/react";
import { DeleteIcon, EditIcon, ViewIcon } from "@chakra-ui/icons";

/**
 * ActionMenu - A reusable dropdown menu component for table action columns
 * 
 * @param {Object} props
 * @param {boolean} props.canView - Whether to show the View option
 * @param {boolean} props.canEdit - Whether to show the Edit option
 * @param {boolean} props.canDelete - Whether to show the Delete option
 * @param {Function} props.onView - Callback when View is clicked
 * @param {Function} props.onEdit - Callback when Edit is clicked
 * @param {Function} props.onDelete - Callback when Delete is clicked
 * @param {Array} props.customActions - Array of custom action objects: { label, icon, onClick, color }
 */
const ActionMenu = ({
    canView = true,
    canEdit = false,
    canDelete = false,
    onView,
    onEdit,
    onDelete,
    customActions = [],
}) => {
    const hasAnyAction = canView || canEdit || canDelete || customActions.length > 0;

    return (
        <Flex justify="center" align="center" w="100%">
            <Menu>
                <MenuButton
                    as={Button}
                    variant="ghost"
                    size="sm"
                    fontWeight="bold"
                    fontSize="xl"
                    color="gray.600"
                    _hover={{ bg: "gray.100" }}
                    px={2}
                    minW="auto"
                    onClick={(e) => e.stopPropagation()}
                >
                    ⋮
                </MenuButton>
                <MenuList minW="120px" shadow="md" zIndex={10}>
                    {canView && onView && (
                        <MenuItem
                            icon={<ViewIcon />}
                            onClick={onView}
                        >
                            View
                        </MenuItem>
                    )}
                    {canEdit && onEdit && (
                        <MenuItem
                            icon={<EditIcon />}
                            onClick={onEdit}
                        >
                            Edit
                        </MenuItem>
                    )}
                    {customActions.map((action, index) => (
                        <MenuItem
                            key={index}
                            icon={action.icon}
                            onClick={action.onClick}
                            color={action.color}
                        >
                            {action.label}
                        </MenuItem>
                    ))}
                    {canDelete && onDelete && (
                        <MenuItem
                            icon={<DeleteIcon color="red.500" />}
                            onClick={onDelete}
                            color="red.500"
                        >
                            Delete
                        </MenuItem>
                    )}
                    {!hasAnyAction && (
                        <MenuItem isDisabled>No actions available</MenuItem>
                    )}
                </MenuList>
            </Menu>
        </Flex>
    );
};

export default ActionMenu;
